// Consent state: nothing leaves the device before consent (docs/PRIVACY.md).
// Strictly-necessary storage (theme, local universe) is not consent-gated.

export type ConsentLevel = "unset" | "all" | "none";

const KEY = "bd.consent";
const listeners = new Set<(level: ConsentLevel) => void>();

export function getConsent(): ConsentLevel {
  try {
    const v = localStorage.getItem(KEY);
    return v === "all" || v === "none" ? v : "unset";
  } catch {
    return "unset";
  }
}

export function setConsent(level: Exclude<ConsentLevel, "unset">): void {
  try {
    localStorage.setItem(KEY, level);
  } catch {
    // Storage unavailable: treat as session-only consent.
  }
  for (const fn of listeners) fn(level);
}

export function onConsentChange(fn: (level: ConsentLevel) => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function telemetryAllowed(): boolean {
  return getConsent() === "all";
}
